/**
 * cleengQuote.js
 *
 * The pricing-page quote: Cleeng's MediaStore `GET /offers/:id` needs no auth and
 * has no customerIP param, so the browser's own IP decides the country — matching
 * what checkout is about to charge (checkout omits currency but does send
 * customerIP; see bkfc-cms routes/checkout.ts). Never cached (`cache: 'no-store'`;
 * Cleeng's own CDN doesn't cache this route either) so one viewer's country never
 * serves another's price.
 */
export async function fetchQuote(offerId) {
  if (!offerId) return null;

  const baseUrl = process.env.REACT_APP_CLEENG_MEDIASTORE_URL;
  if (!baseUrl) {
    console.error('REACT_APP_CLEENG_MEDIASTORE_URL is not set; skipping Cleeng quote fetch');
    return null;
  }

  try {
    const res = await fetch(`${baseUrl}/offers/${offerId}`, {
      cache: 'no-store',
      signal: AbortSignal.timeout(4000),
    });
    if (!res.ok) return null;

    const { responseData } = await res.json();
    if (responseData?.customerPriceInclTax == null || !responseData?.customerCurrency) {
      return null;
    }

    return {
      amount: responseData.customerPriceInclTax,
      currency: responseData.customerCurrency,
    };
  } catch {
    return null;
  }
}
